module.exports = __webpack_public_path__ + "img/2.b316969d.png";